module.exports = __webpack_public_path__ + "img/rank.04231be9.jpg";